module.exports = __webpack_public_path__ + "static/media/speaker-conn.b3f4a2db.jpg";